export const STABLE_VAULT_STRINGS = {
  HEADER: {
    TITLE: "Stable Gain Vault",
    STATS: {
      TVL: "Vault TVL",
      APY: "Estimated APR",
    },
  },
  ASSETS_ACCEPTED: {
    heading: "Assets accepted",
    list: [
      {
        key: "usdt",
        title: "USDT",
        iconKey: "/assets/vaults/usdt.svg",
      },
      {
        key: "usdc",
        title: "USDC",
        iconKey: "/assets/vaults/usdc.svg",
      },
    ],
  },
  SECTIONS: {
    DEPOSIT_WITHDRAW: {
      TABS: [
        { key: "deposit", title: "Deposit" },
        { key: "withdraw", title: "Withdraw" },
        { key: "claim", title: "Claim" },
      ],
      DISCLAIMER: {
        DEPOSIT: "",
        WITHDRAW: "",
      },
    },
    PORTFOLIO: {
      TABS: [
        { key: "overview", title: "Overview" },
        { key: "apr_reports", title: "Strategy Reports", isNew: true },
        { key: "holdings", title: "My Holdings" },
      ],
      HOLDINGS: {
        walletConnect: "Connect your wallet to view your holdings",
        nexusMutual: {
          title:
            "Insure your sbUSD with Nexus Mutual. 10% discount for Gain users.",
          CTA: "Get insurance",
          imgSrc: "/assets/vaults/nexus.svg",
        },
      },
      POINTS: {
        walletConnect: "Connect wallet to view your points",
        supported: [],
      },
      CLAIMS: {
        walletConnect: "Connect wallet to view your claims",
        noData: "No claims data available",
        COLUMNS: ["Asset", "Amount", "Status"],
      },
      HISTORY: {
        walletConnect: "Connect wallet to view your history",
        COLUMNS: ["Date", "Time", "Transaction", "Asset", "Amount", "Status"],
      },
      APR_REPORTS: {
        walletConnect: "Connect wallet to view your history",
        cmsKey: "stable_vault",
        COLUMNS: [
          {
            name: "Strategy",
            key: "strategy_name",
            hasImage: true,
          },
          {
            name: "Allocation",
            isNumeric: true,
            key: "allocation",
          },
          {
            name: "APR on strategy",
            isNumeric: true,
            key: "apr",
            tooltipText:
              "APR offered by the selected strategy, based on its current performance.",
          },
          {
            name: "Realized APR",
            isNumeric: true,
            key: "realized_apr",
            tooltipText:
              "The portion of APR that has been finalised. It reflects returns that are no longer subject to change.",
          },
          {
            name: "Accruing APR",
            isNumeric: true,
            key: "accruing_apr",
            tooltipText:
              "The portion of APR that is currently accruing and will be finalised over time, based on ongoing performance.",
          },
          {
            name: "APR on allocation",
            isNumeric: true,
            key: "apr_on_allocation",
            tooltipText:
              "Effective APR based on the strategy's rate and the proportion of assets allocated to it.",
          },
        ],
      },
    },
    OVERVIEW: {
      TABS: [
        { key: "overview", title: "Overview" },
        { key: "strategies", title: "Strategies" },
      ],
      DATA: {
        MAIN: {
          heading: "Unlock stable returns with DeFi",
          headingIcon: "/assets/vaults/agETHOverview.png",
          desc: "Deposit stablecoins to earn enhanced rewards through curated DeFi strategies. In return, you receive sbUSD, which can be used across DeFi while continuing to accrue rewards.",
          disclaimerLink:
            "https://docs.google.com/document/d/1KnAvqWDWXr-GpU3c1g_CtQU6y1fpxX9oaGRcrx4lcWQ",
        },
        FEES: {
          heading: "Fees & Details",
          data: [
            {
              key: "platform",
              title: "Platform fee",
              value: "1.5%",
              offerValue: "0.375%",
              tooltip: "Launch offer: 75% off on fees until 31st Dec’25",
            },
            {
              key: "performance",
              title: "Performance fee",
              value: "20%",
              offerValue: "5%",
              tooltip: "Launch offer: 75% off on fees until 31st Dec’25",
            },
            {
              key: "redemption",
              title: "Redemption period",
              value: "3 days",
            },
          ],
        },
        PARTNERS: {
          heading: "Vault Partners",
          details: [
            {
              key: "ultrayield",
              imgSrc: "/assets/vaults/ultrayield.svg",
              link: "https://kerneldao.gitbook.io/kernel/getting-started/gain/stable-gain#vault-partners",
              imageWidth: 70,
            },
          ],
        },
      },
      STRATEGIES: {
        COLUMNS: [
          {
            label: "Strategy",
            accessor: "strategy",
          },
          {
            label: "Allocation %",
            accessor: "allocation",
          },
        ],
      },
      RESERVES: {
        COLUMNS: ["Date", "Time", "Block", "Asset", "Amount", "Txn"],
      },
    },
  },
};
